import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { LoadingOptions } from '../../../../models/shared/loading-options';
import { FormBuilder, Validators } from '@angular/forms';
import { ChangeInvestmentInstructionsSubmissionFormViewModel } from './change-investment-instructions-submission-form-view-model';
import { InvestmentInstructionSubmissionFormService } from './investment-instruction-submission-form.service';
import { MemberRecord } from '../../../../models/users/dto/member-record';
import { InvestmentInstructionFormRequest } from '../../../../models/users/requests/investment-instruction-form-request';
import { ChangeInvestmentInstructionSubmissionTypeEnum } from '../../../../models/enum/shared/change-investment-instruction-submission-type.enum';

@Component({
  selector: 'app-change-investment-instructions-submission-form',
  templateUrl: './change-investment-instructions-submission-form.component.html',
  styleUrls: ['./change-investment-instructions-submission-form.component.scss'],
  providers: [ChangeInvestmentInstructionsSubmissionFormViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeInvestmentInstructionsSubmissionFormComponent implements OnChanges, OnDestroy {
  @Input() user!: MemberRecord;
  @Output() loadingOpts = new EventEmitter<LoadingOptions>();
  @Output() formSubmittedEvent = new EventEmitter<InvestmentInstructionFormRequest>();

  @ViewChild('form') formElement!: ElementRef<HTMLFormElement>;

  private viewModel = inject(ChangeInvestmentInstructionsSubmissionFormViewModel);
  private investmentInstructionService = inject(InvestmentInstructionSubmissionFormService);
  private fb = inject(FormBuilder);

  public accountTypeDropdowns$ = this.viewModel.accountTypeDropdowns$;

  public formSubmitted = false;

  public readonly accountTypeErrorMessages = { required: $localize`Account Type is required` };
  public readonly submissionTypeErrorMessages = { required: $localize`Make a selection to continue` };

  public formGroup = this.fb.group({
    submissionType: [this.investmentInstructionService.selectedSubmissionType, Validators.required],
    accountType: [this.investmentInstructionService.selectedAccountTypeId, Validators.required]
  });

  public submitForm(): void {
    this.formSubmitted = true;
    if (this.formGroup.valid) {
      const { submissionType, accountType } = this.formGroup.value;
      if (submissionType !== null && submissionType !== undefined && accountType) {
        const request = new InvestmentInstructionFormRequest(submissionType, accountType);
        this.formSubmittedEvent.emit(request);
      }
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.user) {
      this.viewModel.setUser(this.user);
    }
  }

  public ngOnDestroy(): void {
    this.investmentInstructionService.setSelectedSubmissionType(null);
    this.investmentInstructionService.setSelectedAccountTypeId(undefined);
  }

  protected readonly ChangeInvestmentInstructionSubmissionTypeEnum = ChangeInvestmentInstructionSubmissionTypeEnum;
}
